<template>
	<div id="recoverConfirmCode" class="contentLogin">
		<div :class="[isMobile ? 'modLogin mobile' : 'modLogin']">
			<div class="p-3 mb-5 mt-4 bg-white rounded-2 box-shadow fw-500">

				<div class="logo-login">
					<img src="~@/assets/img/logo-fundo-transparente.svg">
				</div>

				<div class="row mt-2">
					<div class="col-1 pointer" @click="toLogin()">
						<h1>
							<img src="~@/assets/img/icon-prev.svg" class="imagePrevRecoverPassword">
						</h1>
					</div>
					<div class="col-10"><p class="fw-400 text-center login-we-send-a-code-to">{{$t('login_we_send_a_code_to')}}</p></div>
				</div>

				<div class="row">
					<div class="col-1"></div>
					<div class="col-10 text-center"><p class="fw-900">{{ emailMasked }}</p></div>
				</div>

				<form id="form_recover_confirm_code" name="form_recover_confirm_code" v-on:submit.prevent="onSubmit">
					<InputOtp :numInputs="4" :label="$t('login_enter_code')" @update:updateCodeVerification="updateCodeVerification"/>

					<div class="row mt-4">
						<div class="col-2"></div>
						<div class="col-8 text-center">
							<span>{{$t('login_i_didnt_receive_the_email')}}</span>
						</div>
						<div class="col-2"></div>
					</div>
					<div class="row mb-2">
						<div class="col-2"></div>
						<div class="col-8 text-center">
							<span class="pointer forgotYourPasswordText" @click="forgotPassword();">{{$t('login_resend_code')}}</span>
						</div>
						<div class="col-2"></div>
					</div>

					<div class="row mt-5 mb-4">
						<div class="col-2"></div>
						<div class="col-8">
							<input
								type="submit"
								class="form-control btnVerification"
								id="btn_code_verification"
								:value="$t('login_recover_password')"
								@click="confirmAccessCode()"
								:disabled="disabled"
							>
						</div>
						<div class="col-2"></div>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
import InputOtp from './composables/InputOtp.vue';

import loginControl from '@/mixins/Login/loginControl';
import isMobileControl from '@/mixins/Login/isMobileControl';

export default {
	name: 'RecoverConfirmCode',

	mixins: [
		loginControl,
		isMobileControl
	],

	components: {
		InputOtp
	},

	data (){
		return {
			username: null,
			email: '',
			emailMasked: null,
			codeVerification: null,
			password: null,
			disabled: true
		}
	},

	created(){
		this.username = this.$route.params.username;
		this.email = this.$route.params.email;

		this.emailMasked = this.maskedEmail(this.email);
		this.setLanguage();
	},

	watch: {
		codeVerification(){
			this.disabled = true;
			if (this.codeVerification.length == 4) {
				this.disabled = false;

				this.$nextTick(() => {
					this.focus("btn_code_verification");
				});
			}
		},
		emailMasked() {
			if (this.emailMasked == "") {
				this.toLogin();
				return false;
			}
		}
	},
}
</script>

<style lang="scss" scoped>
	::v-deep .imagePrevRecoverPassword {
		margin-left: 20px !important;
		margin-right: 23px !important;

		@media only screen and (max-width: 560px) {
			margin-left: 40px !important;
		}
	}

	::v-deep .login-we-send-a-code-to {
		font-size: x-large;
		margin-top: 10px;

		@media screen and (max-width: 375px) {
			font-size: large;
			margin-top: 15px;
		}
	}

	::v-deep .forgotYourPasswordText {
		color: #007BFF;
		font-weight: 500;
	}
</style>
